export default __webpack_public_path__ + "static/media/App nWayPlay 1.6d80034d.png";